import axios from "axios";

let isRedirectingToLogin = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response?.status === 401;
    const isAdminPage = window.location.pathname.startsWith("/admin");
    const isLoginPage = window.location.pathname === "/admin/login";

    if (isUnauthorized && isAdminPage && !isLoginPage && !isRedirectingToLogin) {
      isRedirectingToLogin = true;
      localStorage.removeItem("ecomdemo_token");
      localStorage.removeItem("ecomdemo_user");
      window.location.replace("/admin/login");
    }

    return Promise.reject(error);
  }
);
